// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".versioning-badge[data-v-247f995e].base-badge{margin-right:unset;color:var(--v-gray-dark);background-color:var(--v-gray-pale)}.versioning-badge--is-dark[data-v-247f995e].base-badge{color:var(--v-gray-light);background-color:var(--v-gray-dark)}.versioning-badge--is-active[data-v-247f995e].base-badge{color:var(--v-blue-primary);background-color:var(--v-white)}", ""]);
// Exports
module.exports = exports;
